import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MaterialModule } from '../material.module'
import { FormAtylComponent } from './form-atyl-components/form-atyl/form-atyl.component'
import { FormAtylControlService } from './form-atyl-control.service'
import { FormAtylService } from './form-atyl.service'
import { MatMenuModule} from '@angular/material/menu';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
		MatMenuModule
    ],
    declarations: [FormAtylComponent],
    exports: [FormAtylComponent],
    providers: [FormAtylControlService, FormAtylService]
})
export class MotorAtylModule { }

//Amélioration du module : Le module rend la récursivité très compliqué, a voir comment la rendre possible constament